
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { IVendorReviewType } from '@/Interfaces';
  import { ReviewVendorSource } from '@/Sources';

  @Component({
    name: 'review-vendor-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class ReviewVendorDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Vendor' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;
    @Prop() public reviewId!: string | null;
    @Prop({ type: Boolean, default: false }) public inline!: boolean;
    @Prop({ default: '' }) public indent!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public clearable!: boolean;

    public source: ReviewVendorSource | IVendorReviewType[] = [];
    public innerValue: IVendorReviewType | null = null;


    public get val(): IVendorReviewType | null { return this.innerValue; }
    public set val(value: IVendorReviewType | null) {
      this.$emit('input', value?.organizationId ?? '');
      this.$emit('vendor-id', value?.vendorId ?? -1);
      this.$emit('review-vendor', value);
      this.innerValue = value;
    }

    @Watch('reviewId', { immediate: true })
    public onReviewIdChange(newReviewId: string | null) {
      this.source = newReviewId === null || newReviewId.length === 0 ? [] : new ReviewVendorSource(newReviewId);
    }

    @Watch('value', { immediate: true })
    public onValueChange(newValue: string) {
      if (Array.isArray(this.source) || this.source.isLoaded) {
        const item = Array.isArray(this.source) ? this.source.find(x => x.organizationId === newValue) : this.source.items.find(x => x.organizationId === newValue);
        this.val = item ?? null;
      }
    }

    @Watch('source.cachedItems')
    public onSourceItemsChange(newItems: IVendorReviewType[]) {
      if (!Array.isArray(this.source) && this.source.isLoaded) {
        this.val = newItems.find(x => x.organizationId === this.value) ?? null;
        this.$emit('items', newItems);
      }
    }

    @Watch('source')
    public onSourceChange(newSource: ReviewVendorSource | IVendorReviewType[]) {
      this.$emit('source', newSource);
      if (Array.isArray(newSource)) {
        this.val = newSource.find(x => x.organizationId === this.value) ?? null;
        this.$emit('items', newSource);
      }
    }
  }
